import _defineProperty from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.anchor.js";
import "core-js/modules/es.number.is-integer.js";
import { getMasterDataApi, createMasterDataApi, updateMasterDataApi, deleteMasterDataApi, bulkPatchMasterDataApi, suggestMasterDataApi, importMasterDataApi } from '@/api/selfAnalysis';
import { columnTotal } from './columnTotals';

/**
 * 主檔 02／03 的維護表格（見 ADR-0011）。
 *
 * 兩張表的欄位不一樣，但操作形狀一樣（複合主鍵 site_code + node_id、必填、CHECK 約束），
 * 所以表格只有這一份，欄位由後端 `/api/trendanalytics/schema` 給的定義長出來。
 * 兩個 Panel 各自傳 `table` 跟 `def` 進來，不各寫一份表格。
 *
 * 「一鍵填入」是這頁的重點：主檔 02 光 f001 就 112 列，「上游節點編號」「電壓型態」
 * 這種欄位常常一整批同值，一列一列點開改是最主要的苦工。
 */
/** 05 的串列編號欄。這一欄會照索引自動帶入，其餘欄位都是人自己填 */
var AUTO_ID_COLUMN = 'string_id';
export default {
  name: 'MasterDataTable',
  props: {
    /** 資料表名，例如 'inverter_topology_nodes' */
    table: {
      type: String,
      required: true
    },
    /** 後端 schema 裡對應這張表的那一段 */
    def: {
      type: Object,
      required: true
    },
    siteCode: {
      type: String,
      default: ''
    },
    /** 只給看的列（05 標的空接位置），照主鍵排進表格；不能選、不能編輯、不算合計 */
    placeholderRows: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      rows: [],
      selected: [],
      /** Shift 範圍選取的起點（畫面上的列序，不是 rows 的索引） */
      anchor: null,
      /** 滑鼠按下時停在哪一列。null = 沒停在任何一列（例如按在表頭上），不起拖曳 */
      dragFrom: null,
      /** 這次按下到放開有沒有跨列拖過，有的話尾隨的那個 click 不要再改選取 */
      dragged: false,
      hoverIndex: null,
      filter: '',
      /** b-table 過濾後的列，合計列用。只在有搜尋字時才準，沒搜尋就看 rows */
      filteredRows: [],
      loading: false,
      saving: false,
      error: '',
      formOpen: false,
      formError: '',
      editing: false,
      form: {},
      /** 上一筆存成功的內容，「帶入上一筆」從這裡抄 */
      lastSaved: null,
      /** 按「空接」清掉之前的值，再按一次還原用 */
      blankBackup: null,
      /** 串列編號被手動改過就不再自動蓋掉（留空代表空接，不能被自動填回去） */
      autoIdTouched: false,
      bulkOpen: false,
      bulkColumn: null,
      bulkValue: null,
      suggestOpen: false,
      suggesting: false,
      /** 這次「產生」走哪條路：'' = 讀遙測，'mppt' = 拿主檔 05 的分組當清單 */
      suggestFrom: '',
      /** 空字串 = 讓後端自己往前找有資料的那天 */
      suggestDate: '',
      suggest: {
        date: '',
        samples: 0,
        inv: 0,
        str: 0,
        rows: [],
        skipped: []
      },
      /** 只有 03 用。遙測裡沒有這兩個數字，要人從模組規格書與主檔 06 填進來 */
      moduleVoc: '',
      moduleCount: ''
    };
  },
  computed: {
    items: function items() {
      var _this = this;
      if (!this.placeholderRows.length) return this.rows;
      var key = function key(r) {
        return _this.def.pk.map(function (c) {
          return r[c];
        });
      };
      // 同一個位置已經有真的列（06 自己標了空接）就不再畫佔位列
      var taken = new Set(this.rows.map(function (r) {
        return key(r).join('/');
      }));
      var extra = this.placeholderRows.filter(function (r) {
        return !taken.has(key(r).join('/'));
      });
      return [].concat(_toConsumableArray(this.rows), _toConsumableArray(extra)).sort(function (a, b) {
        var ka = key(a);
        var kb = key(b);
        var i = ka.findIndex(function (v, n) {
          return v !== kb[n];
        });
        return i < 0 ? 0 : ka[i] < kb[i] ? -1 : 1;
      });
    },
    fields: function fields() {
      var _this2 = this;
      return [{
        key: '_actions',
        label: '',
        stickyColumn: true,
        thStyle: {
          width: '64px'
        }
      }].concat(_toConsumableArray(this.def.columns.map(function (c) {
        return {
          key: c.name,
          label: c.label,
          sortable: true,
          formatter: function formatter(v) {
            return _this2.display(c, v);
          }
        };
      })));
    },
    hasTotals: function hasTotals() {
      return this.def.columns.some(function (c) {
        return c.sum;
      });
    },
    /** 像 Numbers 的狀態列：圈選幾列就只加那幾列，方便拿一台 INV 的串去對 04 那一列 */totalScope: function totalScope() {
      if (this.selected.length) return this.selected;
      return this.filter ? this.filteredRows.filter(function (r) {
        return !r._placeholder;
      }) : this.rows;
    },
    totalLabel: function totalLabel() {
      if (this.selected.length) return "\u5DF2\u9078 ".concat(this.selected.length, " \u5217");
      return this.filter ? "\u641C\u5C0B ".concat(this.filteredRows.length, " \u5217") : '合計';
    },
    totals: function totals() {
      // 空接的列沒有模組，規格空著是對的，不算「缺」
      var key = this.def.unwiredWhenBlank;
      var scope = key ? this.totalScope.filter(function (r) {
        return r[key];
      }) : this.totalScope;
      var t = {};
      var _iterator = _createForOfIteratorHelper(this.def.columns),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var c = _step.value;
          t[c.name] = columnTotal(scope, c);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return t;
    },
    /** 06 表單目前是空接：規格欄不必填，標籤拿掉星號 */formUnwired: function formUnwired() {
      var key = this.def.unwiredWhenBlank;
      return !!key && !this.form[key];
    },
    /** DB 自己算的欄位（06 的串列容量）只在表格裡看，表單不給填 */formColumns: function formColumns() {
      return this.def.columns.filter(function (c) {
        return !c.readonly;
      });
    },
    /** 常填同值的欄位排前面，主鍵不給批次改 */bulkColumnOptions: function bulkColumnOptions() {
      var usable = this.formColumns.filter(function (c) {
        return !c.pk;
      });
      var sticky = usable.filter(function (c) {
        return c.sticky;
      });
      var rest = usable.filter(function (c) {
        return !c.sticky;
      });
      return [{
        value: null,
        text: '（請選）'
      }].concat(_toConsumableArray(sticky.map(function (c) {
        return {
          value: c.name,
          text: "".concat(c.label, "\uFF08\u5E38\u7528\uFF09")
        };
      })), _toConsumableArray(rest.map(function (c) {
        return {
          value: c.name,
          text: c.label
        };
      })));
    },
    bulkCol: function bulkCol() {
      var _this3 = this;
      return this.def.columns.find(function (c) {
        return c.name === _this3.bulkColumn;
      }) || null;
    },
    isTopology: function isTopology() {
      return this.table === 'inverter_topology_nodes';
    },
    isVoltage: function isVoltage() {
      return this.table === 'node_voltage_configs';
    },
    fromMppt: function fromMppt() {
      return this.suggestFrom === 'mppt';
    },
    /** 單片開路電壓 × 串接片數。MPPT 那條路沒這兩個數字就整批產不出來 */hasModuleSpec: function hasModuleSpec() {
      return Number(this.moduleVoc) > 0 && Number(this.moduleCount) > 0;
    },
    suggestTitle: function suggestTitle() {
      if (this.fromMppt) return '由 MPPT串列對應產生節點標準電壓';
      return this.isTopology ? '由遙測產生拓撲節點' : '由遙測產生節點標準電壓';
    },
    /**
     * 只有 02／03 給「由遙測產生」。05 推不出來 —— 遙測裡根本沒有 MPPT 這個層級，
     * pv_v[i] 是一台 INV 的串列攤平成一維，哪幾串共用一個 MPPT 推不出來。
     * 06 的模組規格、方位、傾角遙測裡也都沒有。
     */
    canSuggest: function canSuggest() {
      return this.isTopology || this.isVoltage;
    },
    /** 預覽只給看推出來的那幾欄，其餘留空的不用佔版面 */suggestFields: function suggestFields() {
      var _this4 = this;
      var voltage = ['node_level', 'node_id', 'standard_voltage_v', 'voltage_type', 'rated_min_v', 'rated_max_v', 'source_basis'];
      var show = this.isTopology ? ['node_level', 'node_id', 'node_name', 'parent_node_id', 'source_field_path', 'source_field_name', 'inv_index', 'string_index']
      // 全部空接的 MPPT 照建（不略過），只有備註認得出來，所以那條路要多這一欄
      : this.fromMppt ? [].concat(voltage, ['remark']) : voltage;
      return show.map(function (n) {
        var c = _this4.def.columns.find(function (x) {
          return x.name === n;
        });
        return {
          key: n,
          label: c ? c.label : n
        };
      });
    }
  },
  watch: {
    siteCode: {
      immediate: true,
      handler: function handler() {
        this.load();
      }
    },
    'form.inv_index': function formInv_index() {
      this.fillStringId();
    },
    'form.string_index': function formString_index() {
      this.fillStringId();
    },
    // 編號第二段就是 MPPT 編號，改了要跟著重算
    'form.mppt_no': function formMppt_no() {
      this.fillStringId();
    }
  },
  mounted: function mounted() {
    var _this5 = this;
    // 掛 document 不掛表格：拖到一半滑出表格外才放開，還是要結束拖曳
    this.endDrag = function () {
      _this5.dragFrom = null;
    };
    document.addEventListener('mouseup', this.endDrag);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('mouseup', this.endDrag);
  },
  methods: {
    /**
     * 選取自己管，不用 b-table 的 selectable。
     *
     * 它只有兩種模式，都不夠用：`multi` 是一列一列 toggle，沒有 Shift 範圍；
     * `range` 有 Shift 但點一下會把其他列清掉，跟拖曳圈選打架。
     * 自己管之後三種操作湊得齊：拖曳圈選、Shift 選頭尾之間、Ctrl／⌘ 單獨加減。
     *
     * 列序一律用 `computedItems`（畫面上看到的順序，含過濾與排序），
     * 不是 `this.rows` —— 過濾後還照原始順序算範圍會選到看不見的列。
     */
    visibleRows: function visibleRows() {
      var _this$$refs$tbl;
      return ((_this$$refs$tbl = this.$refs.tbl) === null || _this$$refs$tbl === void 0 ? void 0 : _this$$refs$tbl.computedItems) || this.rows;
    },
    isSelected: function isSelected(item) {
      return this.selected.includes(item);
    },
    rowClass: function rowClass(item) {
      // table-info 是 bootstrap 內建的，跟原本 selected-variant="info" 同一個底色
      if (item !== null && item !== void 0 && item._placeholder) return 'md_placeholder';
      return item && this.isSelected(item) ? 'table-info' : '';
    },
    selectRange: function selectRange(a, b) {
      var _ref = a <= b ? [a, b] : [b, a],
        _ref2 = _slicedToArray(_ref, 2),
        lo = _ref2[0],
        hi = _ref2[1];
      this.selected = this.visibleRows().slice(lo, hi + 1).filter(function (r) {
        return !r._placeholder;
      });
    },
    onRowClicked: function onRowClicked(item, index, e) {
      // 跨列拖曳結束時瀏覽器會補一個 click（目標是共同祖先），不能讓它把圈好的清掉
      if (this.dragged || item._placeholder) return;
      if (e.shiftKey && this.anchor !== null) return this.selectRange(this.anchor, index);
      this.anchor = index;
      if (e.ctrlKey || e.metaKey) {
        this.selected = this.isSelected(item) ? this.selected.filter(function (r) {
          return r !== item;
        }) : [].concat(_toConsumableArray(this.selected), [item]);
      } else {
        // 已經是「只選這一列」再點一次就取消，不然單列選了會沒辦法清掉
        this.selected = this.isSelected(item) && this.selected.length === 1 ? [] : [item];
      }
    },
    onMouseDown: function onMouseDown(e) {
      if (e.button !== 0) return;
      this.dragged = false;
      this.dragFrom = this.hoverIndex;
    },
    onRowHovered: function onRowHovered(item, index) {
      this.hoverIndex = index;
      if (this.dragFrom === null || index === this.dragFrom) return;
      this.dragged = true;
      this.anchor = this.dragFrom;
      this.selectRange(this.dragFrom, index);
    },
    /** 這一列的主鍵。欄位由 def.pk 決定 —— 02／03 是兩欄，05 是三欄 */rowKey: function rowKey(row) {
      var k = {};
      var _iterator2 = _createForOfIteratorHelper(this.def.pk),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var c = _step2.value;
          k[c] = row[c];
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return k;
    },
    rowLabel: function rowLabel(row) {
      return this.def.pk.filter(function (c) {
        return c !== 'site_code';
      }).map(function (c) {
        return row[c];
      }).join(' / ');
    },
    onFormInput: function onFormInput(col) {
      if (col.name === AUTO_ID_COLUMN) this.autoIdTouched = true;
    },
    /** 「空接」鈕：有值就清空並記下來；已經空了就還原記下的值，05 沒記過就重新自動編號 */toggleBlank: function toggleBlank(col) {
      this.autoIdTouched = true;
      if (this.form[col.name]) {
        this.blankBackup = this.form[col.name];
        this.$set(this.form, col.name, null);
        return;
      }
      if (this.blankBackup) {
        this.$set(this.form, col.name, this.blankBackup);
      } else {
        this.autoIdTouched = false;
        this.fillStringId();
      }
    },
    /**
     * 串列編號自動帶入：`INV<INV索引+1>-<MPPT編號>-<這個 MPPT 裡的第幾格>`，例如 `INV1-3-1`。
     *
     * 第三段照「同一台 INV、同一個 MPPT 裡，排在這一格前面的有幾格」算，**空接也算一格**。
     * 所以中間哪一格空接，同一個 MPPT 其他串的編號都不會跟著跑。
     *
     * 舊規則是整台 INV 連號（`INV1-STR6`），空接一跳後面整排位移，光看編號也認不出是哪一格 ——
     * 那正是要解掉的麻煩。規則的權威版本在後端 `topologyFromTelemetry.js` 的 `stringIdOf`，
     * 02 的 STR 節點編號也是照同一條長出來的，兩邊要一起改。
     *
     * 手動改過（含清空成空接）之後就不再自動蓋。
     */
    fillStringId: function fillStringId() {
      if (this.table !== 'mppt_string_map' || this.autoIdTouched) return;
      var num = function num(v) {
        return v === '' || v === null || v === undefined ? NaN : Number(v);
      };
      var inv = num(this.form.inv_index);
      var idx = num(this.form.string_index);
      var mppt = num(this.form.mppt_no);
      if (![inv, idx, mppt].every(Number.isInteger)) return;
      var before = this.rows.filter(function (r) {
        return r.inv_index === inv && r.mppt_no === mppt && r.string_index < idx;
      }).length;
      this.$set(this.form, AUTO_ID_COLUMN, "INV".concat(inv + 1, "-").concat(mppt, "-").concat(before + 1));
    },
    inputType: function inputType(col) {
      if (col.type === 'text' || col.type === 'date') return col.type;
      return 'number';
    },
    display: function display(col, v) {
      if (v === null || v === undefined || v === '') return col.blank || '—';
      if (col.type === 'bool') return v ? '是' : '否';
      return v;
    },
    load: function load() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this6.siteCode) {
                  _context.next = 3;
                  break;
                }
                _this6.rows = [];
                return _context.abrupt("return");
              case 3:
                _this6.loading = true;
                _this6.error = '';
                _context.prev = 5;
                _context.next = 8;
                return getMasterDataApi(_this6.table, _this6.siteCode);
              case 8:
                res = _context.sent;
                _this6.rows = res.data || [];
                _this6.selected = [];
                _this6.anchor = null;
                _context.next = 18;
                break;
              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](5);
                _this6.error = (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.msg) || (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || '讀不到主檔資料';
                _this6.rows = [];
              case 18:
                _context.prev = 18;
                _this6.loading = false;
                return _context.finish(18);
              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 14, 18, 21]]);
      }))();
    },
    /** 空白表單。bool 預設 false（DDL 是 NOT NULL，沒有預設值可以偷懶） */blankForm: function blankForm() {
      var f = {};
      var _iterator3 = _createForOfIteratorHelper(this.def.columns),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var c = _step3.value;
          f[c.name] = c.type === 'bool' ? false : null;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      f.site_code = this.siteCode;
      return f;
    },
    openCreate: function openCreate() {
      this.editing = false;
      this.formError = '';
      this.blankBackup = null;
      this.autoIdTouched = false;
      this.form = this.blankForm();
      // 已經有資料的話，沿用最後一列的常填欄位，省掉重打
      if (!this.lastSaved && this.rows.length) this.lastSaved = _objectSpread({}, this.rows[this.rows.length - 1]);
      this.formOpen = true;
    },
    openEdit: function openEdit(row) {
      this.editing = true;
      this.formError = '';
      this.blankBackup = null;
      // 既有的列本來就有值（或刻意留空代表空接），不要一進來就被自動編號蓋掉
      this.autoIdTouched = true;
      this.form = _objectSpread(_objectSpread({}, this.blankForm()), row);
      this.formOpen = true;
    },
    /** 一鍵自動補上：sticky 欄位整批帶過來，節點編號跟名稱不帶（那兩個每列都不同） */fillFromLast: function fillFromLast() {
      if (!this.lastSaved) return;
      var keep = _objectSpread({}, this.form);
      var _iterator4 = _createForOfIteratorHelper(this.def.columns),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _this$lastSaved$c$nam;
          var c = _step4.value;
          if (!c.sticky) continue;
          keep[c.name] = (_this$lastSaved$c$nam = this.lastSaved[c.name]) !== null && _this$lastSaved$c$nam !== void 0 ? _this$lastSaved$c$nam : null;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.form = keep;
    },
    save: function save() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var body;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this7.saving = true;
                _this7.formError = '';
                _context2.prev = 2;
                body = _objectSpread({}, _this7.form);
                if (!_this7.editing) {
                  _context2.next = 10;
                  break;
                }
                body.key = _this7.rowKey(_this7.form);
                _context2.next = 8;
                return updateMasterDataApi(_this7.table, body);
              case 8:
                _context2.next = 12;
                break;
              case 10:
                _context2.next = 12;
                return createMasterDataApi(_this7.table, body);
              case 12:
                _this7.lastSaved = _objectSpread({}, _this7.form);
                _this7.formOpen = false;
                _context2.next = 16;
                return _this7.load();
              case 16:
                // 上層的案場下拉會標「已有幾列」，不通知就會停在舊數字
                _this7.$emit('changed');
                _context2.next = 22;
                break;
              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2["catch"](2);
                // 後端把 unique/FK/CHECK 違反翻成中文了，直接顯示
                _this7.formError = (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.msg) || (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || '儲存失敗';
              case 22:
                _context2.prev = 22;
                _this7.saving = false;
                return _context2.finish(22);
              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 19, 22, 25]]);
      }))();
    },
    openBulk: function openBulk() {
      this.formError = '';
      this.bulkColumn = null;
      this.bulkValue = null;
      this.bulkOpen = true;
    },
    applyBulk: function applyBulk() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var keys, patch, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this8.bulkCol) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return");
              case 2:
                _this8.saving = true;
                _this8.formError = '';
                _context3.prev = 4;
                keys = _this8.selected.map(function (r) {
                  return _this8.rowKey(r);
                });
                patch = _defineProperty({}, _this8.bulkColumn, _this8.bulkCol.type === 'bool' ? !!_this8.bulkValue : _this8.bulkValue);
                _context3.next = 9;
                return bulkPatchMasterDataApi(_this8.table, keys, patch);
              case 9:
                res = _context3.sent;
                _this8.bulkOpen = false;
                _this8.$swal(res.msg || '已填入');
                _context3.next = 14;
                return _this8.load();
              case 14:
                _context3.next = 19;
                break;
              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](4);
                _this8.formError = (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.msg) || (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message) || '填入失敗';
              case 19:
                _context3.prev = 19;
                _this8.saving = false;
                return _context3.finish(19);
              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[4, 16, 19, 22]]);
      }))();
    },
    openSuggest: function openSuggest() {
      var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.suggestFrom = from;
      this.suggestOpen = true;
      this.fetchSuggest();
    },
    /** 只讀遙測，不寫庫。看過再按「寫入」 */fetchSuggest: function fetchSuggest() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this9.suggest = {
                  date: '',
                  samples: 0,
                  inv: 0,
                  str: 0,
                  rows: [],
                  skipped: []
                };
                _this9.formError = '';
                // MPPT 那條路缺了模組規格就是整批產不出來，開 modal 時先別打那一發注定 400 的 request，
                // 讓人先把上面兩格填完。遙測那條路缺了只是不產 STR 列，還是有東西可看，照打。
                if (!(_this9.fromMppt && !_this9.hasModuleSpec)) {
                  _context4.next = 4;
                  break;
                }
                return _context4.abrupt("return");
              case 4:
                _this9.suggesting = true;
                _context4.prev = 5;
                _context4.next = 8;
                return suggestMasterDataApi(_this9.table, _this9.siteCode, {
                  date: _this9.fromMppt ? '' : _this9.suggestDate,
                  moduleVoc: _this9.moduleVoc,
                  moduleCount: _this9.moduleCount,
                  from: _this9.suggestFrom
                });
              case 8:
                res = _context4.sent;
                _this9.suggest = _objectSpread({
                  skipped: []
                }, res.data);
                // 後端往前找到哪一天就顯示哪一天，省得使用者以為取樣的是今天。
                // MPPT 那條路沒取樣日期，回的是空字串，不要拿去把人選好的日期洗掉
                if (res.data.date) _this9.suggestDate = res.data.date;
                _context4.next = 17;
                break;
              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](5);
                _this9.suggest = {
                  date: '',
                  samples: 0,
                  inv: 0,
                  str: 0,
                  rows: [],
                  skipped: []
                };
                _this9.formError = (_context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.msg) || (_context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.message) || (_this9.fromMppt ? '無法讀取 MPPT串列對應資料' : '無法讀取監控資料');
              case 17:
                _context4.prev = 17;
                _this9.suggesting = false;
                return _context4.finish(17);
              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[5, 13, 17, 20]]);
      }))();
    },
    applySuggest: function applySuggest() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this10.saving = true;
                _this10.formError = '';
                _context5.prev = 2;
                _context5.next = 5;
                return importMasterDataApi(_this10.table, _this10.suggest.rows);
              case 5:
                res = _context5.sent;
                _this10.suggestOpen = false;
                _this10.$swal(res.msg || '已寫入');
                _context5.next = 10;
                return _this10.load();
              case 10:
                _this10.$emit('changed');
                _context5.next = 16;
                break;
              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5["catch"](2);
                _this10.formError = (_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.msg) || (_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.message) || '寫入失敗';
              case 16:
                _context5.prev = 16;
                _this10.saving = false;
                return _context5.finish(16);
              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 13, 16, 19]]);
      }))();
    },
    removeSelected: function removeSelected() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var n, ok, keys, res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                n = _this11.selected.length;
                _context6.next = 3;
                return _this11.$swal({
                  title: "\u522A\u9664 ".concat(n, " \u5217\uFF1F"),
                  text: '刪掉就沒了，同一個 transaction 一次刪完。',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: '刪除',
                  cancelButtonText: '取消'
                });
              case 3:
                ok = _context6.sent;
                if (ok.isConfirmed) {
                  _context6.next = 6;
                  break;
                }
                return _context6.abrupt("return");
              case 6:
                _this11.saving = true;
                _context6.prev = 7;
                keys = _this11.selected.map(function (r) {
                  return _this11.rowKey(r);
                });
                _context6.next = 11;
                return deleteMasterDataApi(_this11.table, keys);
              case 11:
                res = _context6.sent;
                _this11.$swal(res.msg || '已刪除');
                _context6.next = 15;
                return _this11.load();
              case 15:
                _this11.$emit('changed');
                _context6.next = 21;
                break;
              case 18:
                _context6.prev = 18;
                _context6.t0 = _context6["catch"](7);
                _this11.$swal((_context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.msg) || (_context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.message) || '刪除失敗');
              case 21:
                _context6.prev = 21;
                _this11.saving = false;
                return _context6.finish(21);
              case 24:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[7, 18, 21, 24]]);
      }))();
    }
  }
};